import { connect } from 'react-redux';
import MainLogin from './MainLogin';
import { openCancelReservationScreen } from '../../actions/cancelling';
import { setManagementOptionWithSinglePath } from '../../actions/booking';

const mapStateToProps = state => ({
  userIdentified: state.session.userIdentified,
  viaSso: state.session.viaSso,
  pathBasedBooking: state.booking.pathBasedBooking,
  uniquePath: state.booking.uniquePath,
  pathToLoadAfterLogin: state.booking.pathToLoadAfterLogin,
  fetchPathAfterLogin: state.booking.fetchPathAfterLogin,
  managementSelected: state.booking.managementSelected,
  languages: state.organization.languages,
  loginPolicyType: state.organization.loginPolicyType
});
const mapDispatchToProps = dispatch => ({
  openCancelReservationScreen() {
    dispatch(openCancelReservationScreen());
  },
  setManagementOptionWithSinglePath: dispatch(setManagementOptionWithSinglePath)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainLogin);



// WEBPACK FOOTER //
// ./src/components/MainLogin/index.js